import { combineReducers } from 'redux'
import backgroundReducer from './background/reducer'
import hashesReducer from './hashes/reducer'
import serverStatusesReducer from './serverStatuses/reducer'
import twitchReducer from './twitch/reducer'
import versionsReducer from './versions/reducer'

const reducer = combineReducers({
    background: backgroundReducer,
    hashes: hashesReducer,
    serverStatuses: serverStatusesReducer,
    twitch: twitchReducer,
    versions: versionsReducer,
})

export default reducer



// WEBPACK FOOTER //
// ./src/features/Sync/data/reducer.js